var app = angular.module("leonardo");

var IncompleteTaskList = function($scope, FilterService) {
  $scope.recurrence = FilterService.getFilter('recurrence');

  $scope.filterService = FilterService;

  $scope.showRecurrence = function(mode) {
    switch (mode) {
      case 'daily':
        return $scope.recurrence ? $scope.recurrence != 'month' && $scope.recurrence != 'week' : true;
      case 'monthly':
        return $scope.recurrence ? $scope.recurrence != 'day' && $scope.recurrence != 'week' : true;
      case 'weekly':
        return $scope.recurrence ? $scope.recurrence != 'month' && $scope.recurrence != 'day' : true;
      default: return true;
    }
  }
};

app.controller('IncompleteTaskList', ['$scope','FilterService', IncompleteTaskList]);
